import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export const echo = new Echo({
  broadcaster: "pusher",
  key: "4pyf1mdgupez0ypkhwfs",
  cluster: "mt1",
  wsHost: "127.0.0.1",
  wsPort: 9090,
  forceTLS: false,
  disableStats: true,
  authEndpoint: "http://127.0.0.1:8000/broadcasting/auth",
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
    },
  },
});

// Logs للاتصال
echo.connector.pusher.connection.bind("connected", () => {
  console.log("🟢 WebSocket Connected");
});

echo.connector.pusher.connection.bind("disconnected", () => {
  console.log("🔴 WebSocket Disconnected");
});

echo.connector.pusher.connection.bind("error", (err) => {
  console.error("❌ WebSocket Error:", err);
});

export default echo;
